"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkSplitRegex = exports.linkParametrizedKey = void 0;
exports.linkParametrizedKey = '#href';
exports.linkSplitRegex = new RegExp(`(\\${exports.linkParametrizedKey}[0-9])`, 'g');
